import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { getExpertRequest } from "../ReduxStore/actions";
import GenericExpertTabPage from "../MeetExpertPage/GenericExpertTabPage";

const ExpertTabComponent = () => {
  //use for tab handle
  const [value, setValue] = useState("1");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const tabStyle = {
    color: "#555",
    "&.Mui-selected": {
      color: "#F7C332",
    },
  };

  //use redux hooks
  const dispatch = useDispatch();
  const { isLoading, experts_profile } = useSelector(
    (state) => state.expertData
  );

  const [expertPeople, setExpertPeople] = useState([]);

  useEffect(() => {
    dispatch(getExpertRequest());
  }, [dispatch]);

  useEffect(() => {
    // Update local state when experts_profile changes
    // Check if experts_profile is defined and not empty
    if (experts_profile && Object.keys(experts_profile).length !== 0) {
      setExpertPeople(experts_profile.data || []);
    }
  }, [experts_profile]);

  return (
    <div>
      <Box sx={{ width: "100%", maxWidth: "100vw", overflowX: "hidden" }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleChange}
              aria-label="lab API tabs example"
              variant="scrollable"
              scrollButtons="auto"
              TabIndicatorProps={{
                style: {
                  backgroundColor: "#F7C332",
                },
              }}
            >
              <Tab label="Director" value="1" sx={tabStyle} />
              <Tab label="Sales Representative" value="2" sx={tabStyle} />
              <Tab label="Property Management" value="3" sx={tabStyle} />
              <Tab label="Commercial" value="4" sx={tabStyle} />
              <Tab label="Principal" value="5" sx={tabStyle} />
              <Tab label="Valuer" value="6" sx={tabStyle} />
              <Tab label="Strata Management" value="7" sx={tabStyle} />
              <Tab label="Administrator" value="8" sx={tabStyle} />
            </TabList>
          </Box>
          <TabPanel value="1">
            <GenericExpertTabPage
              getRefComment="director"
              expertTabData={expertPeople}
              loading={isLoading}
            />
          </TabPanel>
          <TabPanel value="2">
            <GenericExpertTabPage
              getRefComment="sales_representative"
              expertTabData={expertPeople}
              loading={isLoading}
            />
          </TabPanel>
          <TabPanel value="3">
            <GenericExpertTabPage
              getRefComment="property_management"
              expertTabData={expertPeople}
              loading={isLoading}
            />
          </TabPanel>
          <TabPanel value="4">
            <GenericExpertTabPage
              getRefComment="commercial"
              expertTabData={expertPeople}
              loading={isLoading}
            />
          </TabPanel>
          <TabPanel value="5">
            <GenericExpertTabPage
              getRefComment="principal"
              expertTabData={expertPeople}
              loading={isLoading}
            />
          </TabPanel>
          <TabPanel value="6">
            <GenericExpertTabPage
              getRefComment="valuer"
              expertTabData={expertPeople}
              loading={isLoading}
            />
          </TabPanel>
          <TabPanel value="7">
            <GenericExpertTabPage
              getRefComment="strata_management"
              expertTabData={expertPeople}
              loading={isLoading}
            />
          </TabPanel>
          <TabPanel value="8">
            <GenericExpertTabPage
              getRefComment="administrator"
              expertTabData={expertPeople}
              loading={isLoading}
            />
          </TabPanel>
        </TabContext>
      </Box>
    </div>
  );
};

export default ExpertTabComponent;
